import { combineComponents } from 'utils';
import ReturnPolicyProvider from 'contexts/ReturnPolicy/ReturnPolicyProvider';
import { ActivitiesProvider } from './Activities';
import { AgeRestrictionProvider } from './AgeRestriction';
import { BusinessDayProvider } from './BusinessDay';
import { BusinessRulesProvider } from './BusinessRules';
import { CatalogCategoriesProvider } from './CatalogCategories';
import { CategoriesProvider } from './Categories';
import { ColorPickerProvider } from '@ccm-office/ccm-ui';
import { CommandsMenuProvider } from './CommandsMenu';
import { DevicesProvider } from './Devices';
import { ItemGroupsProvider } from './ItemGroups';
import { LocationsHierarchyProvider } from './LocationsHierarchy';
import { LocationsProvider } from './Locations';
import { MessagesProvider } from './Messages';
import { MetaDataProvider } from './MetaData';
import { PLUGroupsProvider } from './PLUGroups';
import { PLUMenusProvider } from './PLUMenus';
import { ProductsProvider } from './Products';
import { ProfilesProvider } from './Profiles';
import { ReasonCodesProvider } from './ReasonCodes';
import { ResourceDetailsProvider } from './ResourceDetails';
import { StoresProvider } from './Stores';
import { TaxParametersProvider } from './TaxParameters';
import { TendersProvider } from './Tender';
import { TouchpointsProvider } from './Touchpoints';
import { TaxZonesProvider } from './TaxZones';
import { TaxAuthoritiesProvider } from './TaxAuthorities';
import { TaxRatesProvider } from './TaxRates';
import { TenderMenuProvider } from './TenderMenu';
import { TenderGroupProvider } from './TenderGroup';
import { TouchpointDisplaysProvider } from './TouchpointDisplays';
import { WicAgenciesProvider } from './WicAgencies';
import { WicMappingsProvider } from './WicMappings';
import { WicSettingsProvider } from './wic-settings';
import { WicExclusionsProvider } from './WicExclusions';
import { CultureProvider } from './Culture';

const providers = [
  ActivitiesProvider,
  AgeRestrictionProvider,
  BusinessDayProvider,
  BusinessRulesProvider,
  CatalogCategoriesProvider,
  CategoriesProvider,
  ColorPickerProvider,
  CommandsMenuProvider,
  CultureProvider,
  DevicesProvider,
  ItemGroupsProvider,
  LocationsHierarchyProvider,
  LocationsProvider,
  MessagesProvider,
  MetaDataProvider,
  PLUGroupsProvider,
  PLUMenusProvider,
  ProductsProvider,
  ProfilesProvider,
  ReasonCodesProvider,
  ResourceDetailsProvider,
  ReturnPolicyProvider,
  StoresProvider,
  TaxAuthoritiesProvider,
  TaxParametersProvider,
  TaxRatesProvider,
  TendersProvider,
  TenderGroupProvider,
  TouchpointsProvider,
  MessagesProvider,
  TaxZonesProvider,
  TenderMenuProvider,
  TouchpointDisplaysProvider,
  WicAgenciesProvider,
  WicExclusionsProvider,
  WicMappingsProvider,
  WicSettingsProvider,
];

export default combineComponents(providers);
